<template>
  <form id="ticketsForm" ref="myForm" v-kendo-validator>
    <div class="page-header d-flex w-100">
      <div class="title-col d-flex w-50 mt-2">
        <span class="title-icon">
          <b-icon-folder-fill></b-icon-folder-fill>
        </span>
        <span class="title-text">Tenant Setting</span>
      </div>
      <div class="text-right ml-auto"></div>
    </div>
    <div class="page-body k-widget">
      <div class="bg-white p-4">
        <div class="text-right ml-auto">
          <input
            type="button"
            class="k-button k-primary mr-2 mb-3"
            :value="'Save'"
            @click="saveForm"
          />
        </div>
        <div v-if="settingsKey.length !=0">
          <form-generator :schema="settingsKey" :value="formData" @input="inputData"></form-generator>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState,mapActions ,mapMutations} = createNamespacedHelpers("tenantSettings");
import FormGenerator from "@/components/SettingsFields/FormGenerator";

export default {
  data: function() {
    return {
     datVal:{}
    };
  },
       components: {
    FormGenerator,
  },
  computed: {
   ...mapState(["formData","settingsKey"])
  },
  methods: {
    ...mapActions(["getTenantSettings","getFieldSettingsByKey","save"]),
     ...mapMutations(["inputData"]),
    async getDataOnload() {
        await this.$store.dispatch("loadInitialData");
        this.getFieldSettingsByKey();
    },
    saveForm(){
      console.log(this.formData)
      this.save(this.formData).then(()=>{
        this.$store.dispatch('loadInitialData', null, { root: true });
      })
    }
  },

  beforeDestroy() {
    this.unsubscribe();
  },
  mounted: function() {
    this.getDataOnload();
  },
};
</script>